<template>
  <div class="tw-w-full tw-p-8">

    <div class="mb-2 tw-text-2xl tw-font-bold">How much budget do you want to spend for the task?</div>

    <submit-task-select
      :searchable = false
      :options="states.base_data.budgets"
      :filter="(option,search) => option.title.toLowerCase().includes(search.toLowerCase())"
    >
      <template v-slot:option="{option}">
        <submit-task-option
          v-on:click.native.prevent="store.selectBudget(option)"
          :isActive="_.get(states.budget,'id') === option.id"
          :text="option.title"
        />
      </template>
    </submit-task-select>

  </div>
</template>
<script>
  import store from './submit-task-store'
  import SubmitTaskSelect from "./submit-task-select";
  import SubmitTaskOption from "./submit-task-option";

  export default {
    components: {
      SubmitTaskSelect,
      SubmitTaskOption,
    },
    beforeCreate() {
      this.store = store
    },
    data: v => ({
      states: store.states,
    }),
  }
</script>
